import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    description: 'provider step title',
    defaultMessage: 'Enable carriers & see rates <span>{emoji}</span>',
    id: 'oG266w',
  },
  targetedUSDescription: {
    description: 'provider step description',
    defaultMessage: 'Turn on ShipStation Carriers to save up to 84% purchasing labels or insurance.',
    id: '7Cge3g',
  },
  targetedNonUSDescription: {
    description: 'provider step description',
    defaultMessage:
      'Define who handles your shipments, and find the best rates and fastest delivery times. Set up your carriers directly through ShipStation, or add your existing carrier accounts.',
    id: 'hz/BsU',
  },
  addMessage: {
    description: 'provider step add message',
    defaultMessage: 'Enable Carriers',
    id: 'Wcl05X',
  },
  addExisting: {
    description: 'provider step add existing carriers message',
    defaultMessage: 'Add your carrier accounts',
    id: '+FnLpg',
  },
  addFulfillment: {
    description: 'provider step add fulfillment provider',
    defaultMessage: 'Add a fulfillment provider',
    id: '0lf8vE',
  },
  connected: {
    description: 'connected provider message',
    defaultMessage: 'Connected',
    id: 'c4oOTG',
  },
  pendingStatus: {
    description: 'pending approval provider message',
    defaultMessage: 'Pending approval',
    id: '2GJnEi',
  },
  fulfillmentProviderErrorTitle: {
    description: 'onboarding fulfillment registration notification error title',
    defaultMessage: 'ShipStation could not connect to the selected carrier.',
    id: 'e3vvpC',
  },
  fulfillmentProviderRegistrationFailure: {
    description: 'Seller Fulfillment provider registration failure',
    defaultMessage:
      'We were unable to register your fulfillment provider. Please try again. If this issue persists, please reach out to our support team.',
    id: 'iqM+D5',
  },
  fulfillmentProviderFatalError: {
    description: 'Seller Fulfillment provider registration failure',
    defaultMessage:
      "We've encountered an issue working with your fulfillment provider. If this issue persists, please reach out to our support team.",
    id: 'ZdQmYv',
  },
  labelProviderError: {
    description: 'Error message when failure to connect to a provider onboarding',
    defaultMessage: 'Confirm your account details and try connecting the carrier again.',
    id: '7aMnyJ',
  },
});

export default messages;
